import { USER_ADMIN } from '@/constants';
import { remove } from 'lodash-es';
import { USER_LEVEL_KEY } from '~/api/interface';
import { PageKey } from '~/constants/page';

export enum ActionListKey {
  CENTER_ACCOUNT_CHANGE_VERIFY_INFO = 'center_account_change_verify_info', // 账号管理-认证信息-变更认证信息
  UPGRADE_BENEFITS = 'upBenefits', // 升级权益按钮
  IDENTIFY = 'identify', // 主体认证
  TURN_IDENTIFY = 'turnIdentify', // 转授权认证
  COMPANY_VERIFY = 'company_verify', // 企业认证标识
  GO_COMPANY_VERIFY = 'go_company_verify', // 去认证
  RECENTLY_SHARE = 'recently_share', // 最近作品分享团员
  RECENTLY_PLAY = 'recently_play', // 最近作品-播放视频
  RECENTLY_COPY = 'recently_copy', // 最近作品-复制到团队空间

  COLLECTION_SHARE = 'collection_share', // 我的收藏 分享团员
  COLLECTION_PLAY = 'collection_play', // 我的收藏 播放音视频
  COLLECTION_SAVE = 'collection_save', // 我的收藏 另存新作品
  COLLECTION_TEMPLATE = 'collection_template', // 我的收藏 创建成片模板
  COLLECTION_USE_TEMPLATE = 'collection_use_template', // 我的收藏 创作同款

  PUBLISH_TO_YOUYAN_PLATFORM = 'publish_to_youyan_platform', // 发布到有言平台

  PERSONAL_SHARE = 'personal_share', // 个人空间分享
  PERSONAL_TEMP_SHARE = 'personal_temp_share', // 个人空间成片分享
  PERSONAL_COPY = 'personal_copy', // 个人空间复制到团队空间
  PERSONAL_SAVE = 'personal_save', // 我的收藏 另存新作品
  PERSONAL_TEMPLATE = 'personal_template', // 个人空间 创建成片模板
  PERSONAL_USE_TEMPLATE = 'personal_use_template', // 个人空间 创作同款
  PERSONAL_RECOVERY = 'personal_recovery', // 个人空间 恢复
  PERSONAL_PUBLISH = 'personal_publish', // 个人空间 发布
  PERSONAL_UPLOAD = 'personal_upload', // 个人空间 上传
  PERSONAL_CUSTEMCOVER = 'personal_custem_cover', // 个人空间 自定义封面

  TEAM_RENAME = 'team_rename', // 团队空间重命名
  TEAM_DELETE = 'team_delete', // 团队空间删除
  TEAM_PUBLISH = 'team_publish', // 团队空间成片发布
  TEAM_UPLOAD = 'team_upload', // 团队空间 上传
  TEAM_COPY = 'team_copy', // 团队空间  复制到个人空间
  TEAM_SHARE = 'team_share', // 团队空间 分享
  TEAM_SAVE = 'team_save', // 团队空间  另存新作品并编辑
  TEAM_CREATE_PIECES_TEMPLATE = 'create_pieces_template', // 团队空间创建成片模板
  TEAM_BRAND_GUIDELINES = 'team_brand_guidelines', // 团队空间 设置/取消品牌规范
  TEAM_CUSTEMCOVER = 'team_custem_cover', // 团队空间 自定义封面
  TEAM_CANCEL_RENDER = 'team_cancel_render', // 团队空间 作品取消渲染(只有管理员可以操作)
  TEAM_OPUS_CLOSE = 'team_opus_close', // 团队空间 作品关闭(只有管理员可以操作)
  TEAM_OPUS_RETRY = 'team_opus_retry', // 团队空间 作品重新渲染(只有管理员可以操作)
  TEAM_CANCEL_QUEUE = 'team_cancel_queue', // 团队空间 成片取消排队(只有管理员可以操作)
  TEAM_RECYCLING_BIN = 'team_recycling_bin', // 团队空间 回收站(只有管理员可以操作)

  BRAND_GUIDELINES = 'brand_guidelines', // 设置/取消品牌规范
  BRAND_RENAME = 'brand_rename', // 品牌重命名
  BRAND_FOLLOW = 'brand_follow', // 申请跟随与解除
  BRAND_SHARE = 'brand_share', // 品牌分享
  BRAND_PLAY = 'brand_play', // 品牌 - 播放
  BRAND_UPLOAD = 'brand_upload', // 品牌 - 上传
  TEMPLATE_SHARE = 'template_share', // 品牌 - 分享

  REDEMPTION_CODE = 'redemption_code', // 兑换码兑换
  STORAGE_BUY = 'storage_buy', // 加购存储空间
  COIN_BUY = 'coin_buy', // 加购言币
  SIDEBAR_GO_EQUITY = 'sidebar_go_equity', // 左下角点击进入权益管理
}

// 试用、个人
const PersonNumber = [USER_LEVEL_KEY.TASTE, USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE];

// 企业版(标准、旗舰、入门、试用）
export const OrgAccount = [
  USER_LEVEL_KEY.ORG_STANDARD,
  USER_LEVEL_KEY.ORG_FLAGSHIP,
  USER_LEVEL_KEY.TEAM_LIGHT,
  USER_LEVEL_KEY.TEAM_TASTE,
];

// 对应版本权限
const MenuPermission: any = {
  // 体验版
  [USER_LEVEL_KEY.TASTE]: [
    ActionListKey.UPGRADE_BENEFITS,
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.PERSONAL_UPLOAD,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.COLLECTION_SAVE,
    ActionListKey.COLLECTION_TEMPLATE,
    ActionListKey.COLLECTION_USE_TEMPLATE,
    ActionListKey.PERSONAL_SAVE,
    ActionListKey.PERSONAL_TEMPLATE,
    ActionListKey.PERSONAL_USE_TEMPLATE,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.PERSONAL_PUBLISH,
    ActionListKey.PERSONAL_CUSTEMCOVER,
    ActionListKey.REDEMPTION_CODE,
    ActionListKey.PERSONAL_TEMP_SHARE,
    ActionListKey.SIDEBAR_GO_EQUITY,
  ],
  // 个人版
  [USER_LEVEL_KEY.PERSONAL_LITE]: [
    ActionListKey.UPGRADE_BENEFITS,
    ActionListKey.IDENTIFY,
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.PERSONAL_UPLOAD,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.COLLECTION_SAVE,
    ActionListKey.COLLECTION_TEMPLATE,
    ActionListKey.COLLECTION_USE_TEMPLATE,
    ActionListKey.PERSONAL_SAVE,
    ActionListKey.PERSONAL_TEMPLATE,
    ActionListKey.PERSONAL_USE_TEMPLATE,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.PERSONAL_PUBLISH,
    ActionListKey.PERSONAL_CUSTEMCOVER,
    ActionListKey.PERSONAL_TEMP_SHARE,
    ActionListKey.REDEMPTION_CODE,
    ActionListKey.STORAGE_BUY,
    ActionListKey.COIN_BUY,
    ActionListKey.SIDEBAR_GO_EQUITY,
  ],
  // 个人版
  [USER_LEVEL_KEY.PERSONAL]: [
    ActionListKey.UPGRADE_BENEFITS,
    ActionListKey.IDENTIFY,
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.PERSONAL_UPLOAD,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.COLLECTION_SAVE,
    ActionListKey.COLLECTION_TEMPLATE,
    ActionListKey.COLLECTION_USE_TEMPLATE,
    ActionListKey.PERSONAL_SAVE,
    ActionListKey.PERSONAL_TEMPLATE,
    ActionListKey.PERSONAL_USE_TEMPLATE,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.PERSONAL_PUBLISH,
    ActionListKey.PERSONAL_CUSTEMCOVER,
    ActionListKey.PERSONAL_TEMP_SHARE,
    ActionListKey.REDEMPTION_CODE,
    ActionListKey.STORAGE_BUY,
    ActionListKey.COIN_BUY,
    ActionListKey.SIDEBAR_GO_EQUITY,
  ],
  // 企业-团员
  normal: [
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.RECENTLY_SHARE,
    ActionListKey.RECENTLY_COPY,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.COLLECTION_SHARE,
    ActionListKey.COLLECTION_SAVE,
    ActionListKey.COLLECTION_TEMPLATE,
    ActionListKey.COLLECTION_USE_TEMPLATE,
    ActionListKey.PERSONAL_SHARE,
    ActionListKey.PERSONAL_COPY,
    ActionListKey.PERSONAL_SAVE,
    ActionListKey.PERSONAL_TEMPLATE,
    ActionListKey.PERSONAL_USE_TEMPLATE,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.PERSONAL_UPLOAD,
    ActionListKey.PERSONAL_PUBLISH,
    ActionListKey.TEAM_COPY,
    ActionListKey.TEAM_SAVE,
    ActionListKey.BRAND_SHARE,
    ActionListKey.BRAND_PLAY,
    ActionListKey.TEMPLATE_SHARE,
    ActionListKey.PERSONAL_TEMP_SHARE,
    ActionListKey.PERSONAL_CUSTEMCOVER,
    ActionListKey.COMPANY_VERIFY,
  ],
  // 企业-超级管理员
  super: Object.values(ActionListKey).filter(
    item => !item.includes(ActionListKey.REDEMPTION_CODE) && !item.includes(ActionListKey.COIN_BUY)
  ),
};

// 对应过期版本权限
const OverTimePermission: any = {
  [USER_LEVEL_KEY.PERSONAL_LITE]: [
    ActionListKey.UPGRADE_BENEFITS,
    ActionListKey.IDENTIFY,
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.SIDEBAR_GO_EQUITY,
  ],
  // 体验版
  [USER_LEVEL_KEY.TASTE]: [
    ActionListKey.UPGRADE_BENEFITS,
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.COLLECTION_SAVE,
    ActionListKey.COLLECTION_TEMPLATE,
    ActionListKey.COLLECTION_USE_TEMPLATE,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.SIDEBAR_GO_EQUITY,
  ],
  // 个人版
  [USER_LEVEL_KEY.PERSONAL]: [
    ActionListKey.UPGRADE_BENEFITS,
    ActionListKey.IDENTIFY,
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.SIDEBAR_GO_EQUITY,
  ],
  // 企业团员
  normal: [
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.RECENTLY_SHARE,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.COLLECTION_SHARE,
    ActionListKey.BRAND_SHARE,
    ActionListKey.BRAND_PLAY,
    ActionListKey.TEMPLATE_SHARE,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.PERSONAL_SHARE,
    ActionListKey.COMPANY_VERIFY,
  ],
  // 企业超级管理员
  super: [
    ActionListKey.RECENTLY_PLAY,
    ActionListKey.RECENTLY_SHARE,
    ActionListKey.COLLECTION_PLAY,
    ActionListKey.COLLECTION_SHARE,
    ActionListKey.BRAND_SHARE,
    ActionListKey.BRAND_PLAY,
    ActionListKey.TEMPLATE_SHARE,
    ActionListKey.PERSONAL_RECOVERY,
    ActionListKey.PERSONAL_SHARE,
    ActionListKey.TEAM_SHARE,
    ActionListKey.TEAM_BRAND_GUIDELINES,
    ActionListKey.BRAND_GUIDELINES,
    ActionListKey.BRAND_RENAME,
    ActionListKey.BRAND_FOLLOW,
    ActionListKey.TEMPLATE_SHARE,
    ActionListKey.COMPANY_VERIFY,
    ActionListKey.GO_COMPANY_VERIFY,
    ActionListKey.SIDEBAR_GO_EQUITY,
  ],
};

// 页面按钮权限（通用权限）
export const checkPermission = (key: ActionListKey) => {
  const userInfo = useUserInfo().value;
  if (!userInfo) {
    return false;
  }

  // 海外先把 言币/存够购买的入口都关闭
  if (isGlobalVersion() && [ActionListKey.STORAGE_BUY].includes(key)) {
    return false;
  }

  // 是否过期对应操作列表
  const PermissionList = userInfo.is_expired ? OverTimePermission : MenuPermission;

  if (userInfo?.rights_type) {
    const rights = Number(userInfo?.rights_type);
    // 试用、个人
    if (PersonNumber.includes(rights)) {
      const rootList = PermissionList[rights];
      return rootList.includes(key);
    }

    // 企业版本权限
    if (OrgAccount.includes(rights)) {
      // 普通成员
      if (userInfo?.permission === USER_ADMIN.NORMAL) {
        return PermissionList.normal.includes(key);
      }
      // 企业管理员、超级管理员-最高权限
      const rights = PermissionList.super.slice(0);
      if (
        [USER_LEVEL_KEY.ORG_STANDARD, USER_LEVEL_KEY.ORG_FLAGSHIP].includes(
          userInfo.rights_type!
        ) &&
        key === ActionListKey.UPGRADE_BENEFITS
      ) {
        return false;
      }

      if (userInfo?.rights_type === USER_LEVEL_KEY.TEAM_LIGHT) {
        rights.push(ActionListKey.COIN_BUY);
      } //  团队入门版支持常显 key

      if (userInfo.rights_type === USER_LEVEL_KEY.TEAM_TASTE) {
        rights.push(ActionListKey.UPGRADE_BENEFITS);
        remove(rights, v => v === ActionListKey.STORAGE_BUY);
      }

      return rights.includes(key);
    }
  }
};

// 切换账号判断当前页面显示（通用权限）
export const checkRoutePermission = (router: any) => {
  const currentAccount = useUserInfo();
  if (router?.meta?.permission) {
    if (OrgAccount.includes(Number(currentAccount.value?.rights_type))) {
      return router.meta.permission.role.includes(Number(currentAccount.value?.permission));
    }
    return router.meta.permission.level.includes(Number(currentAccount.value?.rights_type));
  }

  return true;
};

// 通过不同角色信息显示不同二维码
export const getUserCode = () => {
  const currentAccount = useUserInfo();

  if (
    !currentAccount.value?.user_id ||
    currentAccount.value?.rights_type === USER_LEVEL_KEY.TASTE
  ) {
    return getFeUrl('/youyan-platform/png/qrcode/default-qrcode.png');
  }

  if (
    [USER_LEVEL_KEY.PERSONAL, USER_LEVEL_KEY.PERSONAL_LITE].includes(
      currentAccount.value?.rights_type
    )
  ) {
    return getFeUrl('/youyan-platform/png/code-person-pay.png');
  }

  return getFeUrl('/youyan-platform/png/code-team.png');
};

export const HOME_ROUTE_LIST: PageKey[] = [
  PageKey.HOME,
  PageKey.RECENTLY_WORKS,
  PageKey.MY_COLLECTION,
  PageKey.PERSONAL_SPACE,
  PageKey.TEAM_SPACE,
  PageKey.BRAND_MANAGE,
];

const getHomePageKey = () => {
  const { hasPagePermission } = usePageAndActionPermissionData();
  return HOME_ROUTE_LIST.find(item => hasPagePermission(item)) || PageKey.HOME;
};

/**
 *
 * 用户进入首页的情况较多，因此做了一些优化处理，避免没有权限的用户每次进入首页都会重定向或者进入no-permission页面
 */
export const goHome = () => {
  location.href = '/';
};

export const goLogin = (query?: any) => {
  const permissionData = usePermissionData();
  if (permissionData.value?.config?.logout_url) {
    if (import.meta.client) {
      const urlObj = new URL(permissionData.value?.config?.logout_url, 'http://localhost');

      Object.keys(query).forEach(key => {
        urlObj.searchParams.append(key, query[key]);
      });
      return (location.href = urlObj.href);
    }
  } else {
    navigateTo({ name: PageKey.LOGIN, query });
  }
};

export const useHomeRoute = () => {
  return { name: getHomePageKey() };
};
